import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEventList";

const getEventListTrackerHook = <T extends TrackEventListParameters<any, any, any, any>>(
    trackFunction: (parameters: T, options?: Toolkit.GoogleAnalytics.Options) => void,
    parameters: Partial<T> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    } as T;

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        ...options,
    };

    return (parameters: Partial<T> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return trackFunction({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default getEventListTrackerHook;
